/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import { BUSINESS_STATUSES, PAYMENT_SOURCES } from '@/lib/consts.js'
import { isEmpty } from 'ramda'

// ACTIVE_OVERDUE business can use application but subscription can be empty due to an import error or CS action.
// If so user is redirected to "buy subscription" view
export const booksyBillingRedirect = ({ store, router, logger }) => {
  if (
    store.getters['business/paymentSource'] === PAYMENT_SOURCES.BOOKSY_BILLING
    && [
      BUSINESS_STATUSES.ACTIVE_OVERDUE,
      BUSINESS_STATUSES.BLOCKED_OVERDUE,
    ].includes(store.getters['business/businessStatus'])
    && isEmpty(store.getters['subscription/subscriptionBilling'])
    && store.getters['identity/isManagerOrHigher']
  ) {
    logger.debug(`empty booksy billing found! >>> your-subscription`)
    return router.push({
      name: 'settings.subscription.your-subscription',
      params: {
        businessId: store.getters['business/businessId'],
      },
    })
  }
}
